import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Flutter SDK captures anonymous events by default. However, this may change depending on your `}<inlineCode parentName="p">{`personProfiles`}</inlineCode>{` `}<a parentName="p" {...{
        "href": "/docs/libraries/flutter#person-profiles-anonymous-vs-identified-persons"
      }}>{`config`}</a>{` when initializing PostHog:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`personProfiles: PostHogPersonProfiles.identifiedOnly`}</inlineCode>{` `}<em parentName="p">{`(recommended)`}</em>{` `}<em parentName="p">{`(default)`}</em>{` - Anonymous events are captured by default. PostHog only captures identified events for users where `}<a parentName="p" {...{
            "href": "/docs/data/persons"
          }}>{`person profiles`}</a>{` have already been created.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`personProfiles: PostHogPersonProfiles.always`}</inlineCode>{` - Capture identified events for all events.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`personProfiles: PostHogPersonProfiles.never`}</inlineCode>{` - Capture anonymous events for all events.`}</p>
      </li>
    </ol>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`final config = PostHogConfig('<ph_project_api_key>');
config.host = POSTHOG_HOST;
config.personProfiles = PostHogPersonProfiles.identifiedOnly;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      